import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Creative } from '@sites/data-hmm/hmm-incubator';
import { produce } from 'immer';
import {
  creativeSearchComponentAction,
  creativeServiceAction,
} from './creative.actions';

export const CreativeKey = 'creative';

export interface CreativeEntityState extends EntityState<Creative> {
  error?: Error;
  loading: boolean;
}

export function selectCreativeId(creative: Creative) {
  return creative.id;
}

export const creativeAdapter: EntityAdapter<Creative> =
  createEntityAdapter<Creative>({
    selectId: selectCreativeId,
  });

export const initialCreativeState: CreativeEntityState =
  creativeAdapter.getInitialState({
    error: undefined,
    loading: false,
  });

export const creativeReducer = createReducer(
  initialCreativeState,
  on(
    creativeServiceAction.listSuccess,
    (state, { creatives }): CreativeEntityState => {
      return creativeAdapter.upsertMany(creatives, state);
    }
  ),
  on(
    creativeSearchComponentAction.init,
    (state): CreativeEntityState => {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }
  ),
  on(
    creativeServiceAction.listFailure,
    (state, { error }): CreativeEntityState =>
      produce(state, (draft) => {
        draft.error = error;
      })
  ),
  on(
    creativeServiceAction.listSuccess,
    (state): CreativeEntityState =>
      produce(state, (draft) => {
        draft.loading = false;
      })
  )
);
